import React, { useRef, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import "./style.scss";

import { useFormSelection } from "../../../context/formContext";
import { api } from "../../../helpers";
import useContentService from "../../../service/getContent";
import {
  normalizeServiceItems,
  serviceImageUrl,
} from "../../../helpers/serviceContent";

const ServiceSlider = () => {
  const { getContentByType } = useContentService();
  const [slides, setSlides] = useState([]);
  const { selectedService, setSelectedService } = useFormSelection();
  const swiperRef = useRef(null);

  useEffect(() => {
    getContentByType("service", (data) => {
      const mapped = normalizeServiceItems(data);
      if (mapped) setSlides(mapped);
    });
  }, []);

  const handleSlideChange = (swiper) => {
    const newService = slides[swiper.realIndex]?.type;
    if (newService && newService !== selectedService) {
      setSelectedService(newService);
    }
  };

  useEffect(() => {
    if (!swiperRef.current || slides.length === 0) return;

    const swiper = swiperRef.current;
    const targetIndex = slides.findIndex(
      (slide) => slide.type === selectedService
    );

    if (targetIndex !== -1 && swiper.realIndex !== targetIndex) {
      swiper.slideToLoop(targetIndex);
    }
  }, [selectedService, slides]);

  if (slides.length === 0) {
    return null;
  }

  return (
    <section className="service-slider">
      <Swiper
        modules={[Autoplay, Navigation]}
        navigation
        loop
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        onSlideChange={handleSlideChange}
        slidesPerView={1}
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide._id ?? slide.type}>
            <div className="service-slide">
              <div className="service-slide__text">
                <h2>{slide.title}</h2>
                <p>{slide.text ?? ""}</p>
              </div>
              <div className="service-slide__image">
                <img
                  src={serviceImageUrl(api, slide.image)}
                  alt={slide.title}
                />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default ServiceSlider;
